import React from 'react';
import { ReturnAddressListTemplate } from 'themes/modules/return-address/pages';
import { ReturnAddressListViewStore } from 'modules/return-address/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ReturnAddressListViewStore(rootStore), 'returnAddressListViewStore')
class ReturnAddressList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<ReturnAddressListTemplate
				{...this.props}
				actions={this.props.returnAddressListViewStore}
				viewStore={this.props.returnAddressListViewStore}
			/>
		);
	}
}

export default ReturnAddressList;



// WEBPACK FOOTER //
// ./src/modules/return-address/pages/ReturnAddressList.jsx